export default __webpack_public_path__ + "static/media/roxas.b0337574.jpg";